import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IntercomService } from '@epicuro-next/platform/intercom';
import {
  selectSiteId,
  selectSubSiteId,
} from '@epicuro-next/state/session-state';
import { createEffect } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Injectable()
export class RoutingEffects {
  constructor(
    private intercom: IntercomService,
    private router: Router,
    private store: Store,
  ) {}

  public navigated$ = createEffect(
    () =>
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged(),
        concatLatestFrom(() => [
          this.store.pipe(select(selectSiteId)),
          this.store.pipe(select(selectSubSiteId)),
        ]),
        tap(([, site, subSite]) => {
          this.intercom.update({
            site,
            subSite,
          });
        }),
      ),
    { dispatch: false },
  );
}
